import { useQuery } from '@tanstack/react-query';
import { type SchedulerRunsListQuery } from '@utazzo/shared';

import { listSchedulerJobs, listSchedulerRuns } from './scheduler.api';

/// Jobs + runs are fetched on demand only. The page Refresh button
/// in the header re-fires both queries; we don't poll on a timer
/// because the cron tick cadence (minutes / hours) is much slower
/// than any reasonable polling interval and the auto-refresh just
/// burned screen flickers + needless network requests on a page
/// that admins read, not watch.
export const useSchedulerJobs = () =>
  useQuery({
    queryKey: ['scheduler', 'jobs'],
    queryFn: listSchedulerJobs,
    staleTime: 30_000,
  });

export const useSchedulerRuns = (query: SchedulerRunsListQuery) =>
  useQuery({
    queryKey: ['scheduler', 'runs', query],
    queryFn: () => listSchedulerRuns(query),
    staleTime: 15_000,
    placeholderData: (prev) => prev,
  });
